(function() {
  'use strict';

  /* ── Helpers ── */
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function imgUrl(url, size) {
    if (!url) return '';
    // Shopify image size transform
    return url.replace(/(\.[a-z]+)(\?|$)/, '_' + size + '$1$2');
  }

  /* ── DOM refs ── */
  var overlay  = document.getElementById('ef-drawer-overlay');
  var panel    = document.getElementById('ef-drawer-panel');
  var closeBtn = document.getElementById('ef-drawer-close');
  var itemsEl  = document.getElementById('ef-drawer-items');
  var emptyEl  = document.getElementById('ef-drawer-empty');
  var footerEl = document.getElementById('ef-drawer-footer');
  var countEl  = document.getElementById('ef-drawer-count');
  var subtotalEl = document.getElementById('ef-drawer-subtotal'); // legacy — may be null after Total-only redesign
  var totalEl  = document.getElementById('ef-drawer-total');
  var contBtn  = document.getElementById('ef-drawer-continue');
  var warrantyEl = document.getElementById('ef-drawer-warranty');

  /* ── State ── */
  var isOpen = false;
  var isUpdating = false;

  /* ── Open / Close ── */
  function open() {
    if (isOpen) return;
    isOpen = true;
    // Revalidate the previous cart's warranty label before showing it after an add.
    if (warrantyEl) warrantyEl.style.visibility = 'hidden';
    /* Start the slide-in animation FIRST so it runs smoothly. Defer the heavy
       work (cart fetch + DOM rebuild + body overflow change) until after the
       animation completes. */
    requestAnimationFrame(function() {
      overlay.classList.add('is-open');
      panel.classList.add('is-open');
      /* Toggle body class so .ef-cfg-strip + .ef-cfg-mantel-strip can hide
         when drawer is open (was staying visible orphaned at top of viewport
         while header was scrolled away). User feedback 2026-05-03. */
      document.body.classList.add('ef-cart-drawer-open');
    });
    setTimeout(function() {
      document.body.style.overflow = 'hidden';
      if (panel) panel.focus({ preventScroll: true });
      refresh();
    }, 350);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('ef-cart-drawer-open');
  }

  /* ── Render ── */
  /* Exact native Woodland products are standard catalog sets, not cut-to-opening doors.
     Shopify product_id is authoritative; buyer-editable line properties never grant this exception. */
  function isWoodlandStandardLine(item) {
    var handles = {7578795343954:'24-woodland-timbers-vented-gas-log-set-hargrove',7578795376722:'30-woodland-timbers-vented-gas-log-set-hargrove',7578795409490:'36-woodland-timbers-vented-gas-log-set-hargrove'};
    var expected = handles[String(item.product_id)];
    return !!expected && (!item.handle || item.handle === expected);
  }

  function renderCart(cart) {
    /* Bromic / Lexington scope: classify only Shopify's actual cart line vendor, never titles or
       customer-editable properties. Mixed carts cannot inherit a door warranty. */
    if (warrantyEl) {
      var hasProductSpecificWarranty = cart.items.some(function(item) {
        var vendor = String(item.vendor || '').trim().toLowerCase();
        return vendor === 'bromic' || vendor === 'lexington hearth' || isWoodlandStandardLine(item);
      });
      warrantyEl.textContent = warrantyEl.getAttribute(hasProductSpecificWarranty ? 'data-product-specific' : 'data-default');
      warrantyEl.style.visibility = '';
    }
    var mainCount = 0;
    cart.items.forEach(function(item) {
      if (!item.properties || !item.properties['_parent_product']) mainCount += item.quantity;
    });
    countEl.textContent = mainCount;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    totalEl.textContent = formatMoney(cart.total_price);

    if (mainCount === 0) {
      itemsEl.style.display = 'none';
      emptyEl.style.display = '';
      footerEl.style.display = 'none';
      return;
    }

    itemsEl.style.display = '';
    emptyEl.style.display = 'none';
    footerEl.style.display = '';

    // Separate surcharge items from main items, keyed by _config_id
    var surchargeMap = {};
    var mainItems = [];
    cart.items.forEach(function(item) {
      var props = item.properties || {};
      if (props['_parent_product']) {
        var mapKey = props['_config_id'] || props['_parent_product'];
        if (!surchargeMap[mapKey]) surchargeMap[mapKey] = [];
        surchargeMap[mapKey].push({
          option_type: props['_option_type'] || '',
          variant_title: item.variant_title || item.product_title,
          price: item.final_price,
          /* T-CART2: the line price is what the footer total is made of. The
             unit price is kept for reference but every displayed number below
             is a line price, so line + breakdown + footer agree at any qty. */
          line_price: (item.final_line_price != null ? item.final_line_price : item.final_price)
        });
      } else {
        mainItems.push(item);
      }
    });

    /* §R9-H24 (2026-09-03) - ROUND-9-SPEC H24. The drawer orders by GROUP total,
       descending, exactly as the cart page does. Sorting the ARRAY before render is
       safe here in a way that reordering the page's Liquid loop would not be: every
       control this file writes carries its own data-key, and nothing - not the click
       handler, not cleanOrphans(), not removeWithSurcharges() - indexes by position. */
    function groupTotalOf(item) {
      var cid = item.properties ? item.properties['_config_id'] : null;
      var list = surchargeMap[cid] || surchargeMap[item.product_title] || [];
      var t = item.final_line_price;
      for (var gi = 0; gi < list.length; gi++) {
        t += (list[gi].line_price != null ? list[gi].line_price : list[gi].price);
      }
      return t;
    }
    mainItems.sort(function (a, b) { return groupTotalOf(b) - groupTotalOf(a); });

    /* Properties to skip in pills (shown as add-ons instead) */
    var skipProps = ['width', 'height', 'opening size', 'size category', 'configured price'];

    /* §R9-H21 (2026-09-03) — ROUND-9-SPEC H21. Both renderers threw the property
       NAME away, so a mantel line read `42"` · `6"` · `14"` and a cfg-simple line
       read two bare ranges. ONE rule, shared with sections/ef-cart.liquid: a
       dimension key renders `key: value`; everything else stays value-only (a
       finish name needs no label). The label vocabulary is deliberately short
       because R9-G1 asserts /^(Opening|Length|Height|Depth|Width|Fit): / on every
       whitelisted chip — `Shelf Length` therefore renders `Length: 42"`, not
       `Shelf Length: 42"`. The context is already carried by the product title.
       Nothing here changes the pill COUNT on a door or a mantel line, which is
       the other half of R9-G1. */
    var DIM_LABELS = {
      'opening width': 'Width', 'opening height': 'Height',
      'shelf length': 'Length', 'shelf height': 'Height', 'shelf depth': 'Depth',
      'width': 'Width', 'height': 'Height',
      'fit': 'Fit', 'fit type': 'Fit'
    };

    var html = '';
    var anyConfigured = false;
    var anyCustom = false;
    /* §R9-H26: the wording comes from snippets/ef-orderform-returns-claim.liquid
       through the hidden node the drawer template writes. No literal lives here. */
    var claimsEl = document.getElementById('ef-drawer-returns-claims');
    var RETURNS = {
      standard: claimsEl ? (claimsEl.getAttribute('data-standard') || '') : '',
      custom: claimsEl ? (claimsEl.getAttribute('data-custom') || '') : ''
    };
    mainItems.forEach(function(item) {
      var image = item.image || (item.featured_image && item.featured_image.url) || '';
      if (image) image = imgUrl(image, '200x200');

      /* Finish-sample thumbnail: render a color/swatch tile from line-item
         properties so cart shows the actual finish picked, not the generic
         single-variant sample-product image. When _finish_image or
         _finish_color is present (sample line item), the swatch takes
         priority over item.image. */
      var finishSwatchStyle = '';
      if (item.properties) {
        var fImg = item.properties['_Finish Image'] || item.properties['_finish_image'];
        var fHex = item.properties['_Finish Color'] || item.properties['_finish_color'];
        if (fImg && /^https?:\/\//.test(fImg)) {
          finishSwatchStyle = 'background-image:url(' + fImg.replace(/ /g, '%20') + ');background-size:cover;background-position:center;background-color:#f0e8da;';
        } else if (fHex) {
          var safeHex = fHex.replace(/[^#a-zA-Z0-9(),. %]/g, '');
          finishSwatchStyle = 'background:' + safeHex + ';';
        }
        /* Sample lines must show the finish, not the generic variant image. */
        if (finishSwatchStyle) image = '';
      }

      /* Build config pills (horizontal chips) — §R9-H21 */
      var pillsHtml = '';
      if (item.properties) {
        var pills = [];
        /* The merged dimension pill. Built from Width + Height (doors) or, when
           those are absent, from Opening Width + Opening Height (cfg-simple),
           and it now ENDS WITH `opening`. A bare `36 1/8" × 28 1/4"` is ambiguous
           between the hole and the door, and that ambiguity is the most
           expensive error in this business. Whichever pair feeds the pill is
           removed from the chip loop so nothing renders twice. */
        var dimW = item.properties['Width'];
        var dimH = item.properties['Height'];
        var dimKeys = null;
        if (dimW && dimH) {
          dimKeys = ['width', 'height'];
        } else if (item.properties['Opening Width'] && item.properties['Opening Height']) {
          dimW = item.properties['Opening Width'];
          dimH = item.properties['Opening Height'];
          dimKeys = ['opening width', 'opening height'];
        }
        var keys = Object.keys(item.properties);
        keys.forEach(function(key) {
          var val = item.properties[key];
          if (!key || key.charAt(0) === '_' || /^Photo [123] - /.test(key) || !val || val === '') return;
          var kd = key.toLowerCase();
          if (skipProps.indexOf(kd) !== -1) return;
          if (dimKeys && dimKeys.indexOf(kd) !== -1) return;
          var lab = DIM_LABELS[kd];
          /* `Fit Type: Overlap Fit` would say Fit twice. §8 row 18 is `Fit: Overlap`. */
          if (lab === 'Fit') val = String(val).replace(/\s*Fit$/, '');
          pills.push('<span class="ef-drawer-config-pill">' + (lab ? escHtml(lab + ': ' + val) : escHtml(val)) + '</span>');
        });
        if (dimKeys) pills.unshift('<span class="ef-drawer-config-pill">' + escHtml(dimW) + ' × ' + escHtml(dimH) + ' opening</span>');
        if (pills.length > 0) {
          pillsHtml = '<div class="ef-drawer-config">' + pills.join('') + '</div>';
        }
      }

      /* Each submitted photo has a named link; legacy orders retain every stored URL. */
      var photoHtml = '', photoProps = item.properties || {}, photoEntries = Object.keys(photoProps).filter(function(key) { return /^Photo [123] - /.test(key); }).sort().map(function(key) { return { label: key.replace(' - ', ': '), url: photoProps[key] }; });
      if (!photoEntries.length) ['_Photo URL','_Photo URL 2','_Photo URL 3'].forEach(function(key, i) { if (photoProps[key]) photoEntries.push({ label: 'Photo ' + (i + 1), url: photoProps[key] }); });
      photoEntries.forEach(function(photo) {
        if (!/^https:\/\//i.test(photo.url)) return;
        photoHtml += '<a class="ef-drawer-photo" href="' + escAttr(photo.url) + '" target="_blank" rel="noopener noreferrer" style="display:flex;align-items:center;gap:10px;min-height:44px;margin-top:8px;color:#654925;font-size:13px;text-decoration:underline;text-underline-offset:3px;"><img src="' + escAttr(photo.url) + '" alt="" width="44" height="44" loading="lazy" style="width:44px;height:44px;object-fit:contain;border-radius:6px;background:#f5f2ec;">' + escHtml(photo.label) + '</a>';
      });

      /* Cross-sell "Personalize" deep-link — items added one-tap from "Complete Your Hearth"
         carry _cross_sell + _needs_config; let the shopper open the product to pick specs
         instead of waiting for the confirm call. */
      var personalizeHtml = '';
      if (item.properties && item.properties['_cross_sell'] && item.url) {
        personalizeHtml =
          '<div style="margin-top:6px;">' +
            '<a href="' + escAttr(item.url) + '" ' +
              'style="display:inline-flex;align-items:center;gap:6px;font-size:11px;color:#8A6A43;text-decoration:underline;text-underline-offset:2px;">' +
              '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>' +
              'Personalize — pick your specs' +
            '</a>' +
          '</div>';
      }

      /* Build surcharge add-ons — match by _config_id first, then product title */
      var addonsHtml = '';
      var cfgId = item.properties ? item.properties['_config_id'] : null;
      var itemSurcharges = surchargeMap[cfgId] || surchargeMap[item.product_title] || [];
      var addonsTotal = 0;
      if (itemSurcharges.length > 0) {
        addonsHtml = '<div class="ef-drawer-addons">';
        itemSurcharges.forEach(function(s) {
          var rowPrice = (s.line_price != null ? s.line_price : s.price);
          addonsTotal += rowPrice;
          addonsHtml +=
            '<div class="ef-drawer-addon-row">' +
              '<span class="ef-drawer-addon-left">' +
                '<span class="ef-drawer-addon-dot"></span>' +
                escHtml(s.option_type) + ': ' + escHtml(s.variant_title) +
              '</span>' +
              '<span class="ef-drawer-addon-price">+' + formatMoney(rowPrice) + '</span>' +
            '</div>';
        });
        addonsHtml += '</div>';
      }

      /* T-CART2: the price on the line is the GROUP total (base + every option
         listed above it). The base is kept as a quiet sub-line so the customer
         can still see what the door itself costs. */
      var groupTotal = item.final_line_price + addonsTotal;

      /* §R9-H22 (2026-09-03) - ROUND-9-SPEC H22(a)(e). A made-to-order door at
         quantity 2 is an order EF confirms, not a `+`. The stepper comes off any
         line the configurator wrote (identified by `_config_id`, which is a
         superset of "has surcharge rows" - a build whose every option is the
         default has no surcharge line but is still made to measure). Accessories
         keep theirs.
         THE CODE PATH IS NOT DELETED. changeItem() still cascades quantity to the
         `_config_id` siblings and removeWithSurcharges() still takes them with it;
         T-CART2 proved that sync and cleanOrphans() still calls it. Only the
         control is gone. Every deletion continues to go through change.js BY LINE
         KEY (feedback_cart_update_stale_key_wipes_variant). */
      var isLexingtonStandard = item.vendor === 'Lexington Hearth' && item.properties && item.properties['_lxc_standard'] === '1';
      var isWoodlandStandard = isWoodlandStandardLine(item);
      var isConfigured = !!(item.properties && item.properties['_config_id']) && !isLexingtonStandard && !isWoodlandStandard;
      if (isConfigured) anyConfigured = true;

      /* §R9-H26 (P1 correction). The return position is a PER LINE fact.
         STANDARD IS TESTED FIRST: a cfg-simple line carries both a `Size` property
         and a `_config_id`, and exactly one sentence may appear on a line. */
      var _p = item.properties || {};
      var returnsForm = null;
      /* `Size` is written ONLY when the tier is not S (ef-orderform-simple.js:395),
         so an S-tier standard door has no `Size` and would otherwise fall through to
         `custom` and be told, falsely, that it cannot be returned. `Opening Width` /
         `Opening Height` are written by ef-orderform-simple.js:393-394 on EVERY
         cfg-simple line and by nothing else - the wizard writes `Width`/`Height`. */
      if (isWoodlandStandard) returnsForm = null;
      else if (_p['Size'] || _p['Opening Width'] || _p['Opening Height']) returnsForm = 'standard';
      else if (_p['_config_id'] || _p['Width'] || _p['Height'] || _p['Shelf Length']) returnsForm = 'custom';
      if (returnsForm === 'custom') anyCustom = true;
      var returnsHtml = returnsForm
        ? '<p class="ef-drawer-returns" data-returns="' + returnsForm + '">' + escHtml(RETURNS[returnsForm] || '') + '</p>'
        : '';

      if(isLexingtonStandard || isWoodlandStandard) returnsHtml='<p class="ef-drawer-returns" data-returns="product-specific"><a href="/pages/shipping-returns">Check product-specific return terms</a></p>';

      /* §R9-H23. `Edit build` is rendered IF AND ONLY IF this exact build has a
         restoring link on this device. No key -> no control (never a link that
         silently starts a fresh build). Mantel lines never have one. */
      var editHref = null;
      if (isConfigured) {
        try { editHref = localStorage.getItem('ef_edit_' + item.properties['_config_id']); } catch (e) { editHref = null; }
      }
      var editHtml = editHref
        ? '<button type="button" class="ef-drawer-edit" data-ef-edit-build data-action="edit" data-key="' + item.key + '" data-cfg="' + escAttr(item.properties['_config_id']) + '">Edit build</button>'
        : '';
      var qtyHtml = isConfigured
        ? '<span class="ef-drawer-madeto">Made to order</span>'
        : '<div class="ef-drawer-qty">' +
            '<button type="button" aria-label="Decrease quantity" data-action="minus" data-key="' + item.key + '">&#8722;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" aria-label="Increase quantity" data-action="plus" data-key="' + item.key + '">+</button>' +
          '</div>';

      html +=
        '<div class="ef-drawer-item" data-key="' + item.key + '"' + (isConfigured ? ' data-ef-configured="1"' : '') + '>' +
          '<div class="ef-drawer-item-top">' +
            (image
              ? '<img class="ef-drawer-item-img" src="' + escAttr(image) + '" alt="' + escAttr(item.product_title) + '" loading="lazy">'
              : (finishSwatchStyle
                  ? '<div class="ef-drawer-item-img ef-drawer-item-img--swatch" style="' + finishSwatchStyle + '" aria-label="Finish color swatch"></div>'
                  : '<div class="ef-drawer-item-img"></div>')) +
            '<div class="ef-drawer-item-body">' +
              (item.vendor ? '<p class="ef-drawer-item-vendor">' + escHtml(String(item.vendor).replace(/\bStoll(?: Industries)?\b/gi, 'Design Specialties')) + '</p>' : '') +
              /* §R9-H24c: the same truncation the cart page has used since :1939.
                 The pipe suffix is a page-title problem, not a cart problem. */
              '<p class="ef-drawer-item-title">' + escHtml(String(item.product_title).split(' | ')[0].split(' - ')[0]) + '</p>' +
              /* Render variant title (e.g. '60" Width x 8" Height x 8" Depth')
                 below product title — was missing in drawer but present on full
                 cart page. Skip Shopify's default placeholder. */
              ((item.variant_title && item.variant_title !== 'Default Title')
                ? '<p class="ef-drawer-item-variant">' + escHtml(item.variant_title) + '</p>'
                : '') +
              pillsHtml +
              returnsHtml +
              photoHtml +
              personalizeHtml +
            '</div>' +
          '</div>' +
          addonsHtml +
          '<div class="ef-drawer-item-footer">' +
            '<div class="ef-drawer-item-actions">' +
              qtyHtml +
              editHtml +
              '<button type="button" class="ef-drawer-remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
            '<div class="ef-drawer-item-price">' + formatMoney(groupTotal) + '</div>' +
            (addonsTotal > 0
              ? '<p class="ef-drawer-item-base">Base ' + formatMoney(item.final_line_price) +
                ' + options ' + formatMoney(addonsTotal) + '</p>'
              : '') +
          '</div>' +
        '</div>';
    });

    itemsEl.innerHTML = html;

    /* §R9-H22(b). The three assurance lines live ONCE, in the fixed footer,
       above the checkout button - never per line (+58 px per line on a 390 px
       panel, and it reads as filler). They are about a made-to-measure product,
       so an accessories-only cart does not get them. */
    var assure = document.getElementById('ef-drawer-assure');
    /* §R9-H26: gated on a CUSTOM line, not merely a configured one - a
       quick-ship standard door is not built to a measurement either. */
    if (assure) assure.style.display = anyCustom ? '' : 'none';
  }

  function escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }
  function escAttr(s) {
    return (s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  /* ── Fetch & update ── */
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cleanOrphans(cart);
        renderCart(cart);
        dispatchChange(cart);
      })
      .catch(function(err) {
        console.error('[EFCartDrawer] fetch error', err);
      });
  }

  /* Sync drawer state on every page load — server-rendered Liquid may be
     stale vs actual cart (browser cache, bfcache restore). */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) refresh();
  });

  function cleanOrphans(cart) {
    var parentTitles = {};
    var configIds = {};
    var parentQtyByCfg = {};
    cart.items.forEach(function(item) {
      if (!item.properties || !item.properties['_parent_product']) {
        parentTitles[item.product_title] = true;
        if (item.properties && item.properties['_config_id']) {
          configIds[item.properties['_config_id']] = true;
          parentQtyByCfg[item.properties['_config_id']] = item.quantity;
        }
      }
    });
    var orphans = {};
    // Lexington delivery is one service per cart; remove it when no selected mantel remains.
    var needsLiftgate = cart.items.some(function(item){return item.vendor === 'Lexington Hearth' && item.properties && item.properties['Liftgate delivery'] === 'Yes (+$175)';});
    var keptLiftgate = false;
    cart.items.forEach(function(item){if(item.variant_id !== 42753331757138)return;var desired = needsLiftgate && !keptLiftgate ? 1 : 0;keptLiftgate = true;if(item.quantity !== desired)orphans[item.key] = desired;});
    cart.items.forEach(function(item) {
      if (!item.properties || !item.properties['_parent_product']) return;
      var cid = item.properties['_config_id'];
      if (cid && configIds[cid]) {
        /* 2026-07-28 heal: paid-option lines must track parent qty (legacy carts
           where qty was bumped before the cascade fix shipped). Only ever raise,
           never lower — protects any future qty-as-multiplier lines. */
        var pq = parentQtyByCfg[cid];
        if (pq > 1 && item.quantity < pq) orphans[item.key] = pq;
        return;
      }
      if (!cid && parentTitles[item.properties['_parent_product']]) return;
      orphans[item.key] = 0;
    });
    if (!Object.keys(orphans).length) return;
    /* 2026-08-31: removals one key at a time via /cart/change.js. /cart/update.js with a
       key that a racing cleanup already removed falls back to the VARIANT id and wipes every
       line of that variant (a sibling configuration's surcharge). change.js on a stale key 404s. */
    var post = function(url, body) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function(r) { return r.ok ? r.json() : null; }).catch(function() { return null; });
    };
    var removeKeys = Object.keys(orphans).filter(function(k) { return orphans[k] === 0; });
    var heals = {};
    Object.keys(orphans).forEach(function(k) { if (orphans[k] !== 0) heals[k] = orphans[k]; });
    var chain = Promise.resolve(null);
    removeKeys.forEach(function(k) { chain = chain.then(function() { return post('/cart/change.js', { id: k, quantity: 0 }); }); });
    if (Object.keys(heals).length) chain = chain.then(function() { return post('/cart/update.js', { updates: heals }); });
    chain.then(function() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); }); })
      .then(function(updatedCart) { if (updatedCart && updatedCart.items) { renderCart(updatedCart); dispatchChange(updatedCart); } })
      .catch(function() {});
  }

  function changeItem(key, qty) {
    if (isUpdating) return;
    isUpdating = true;

    if (qty === 0) {
      removeWithSurcharges(key);
      return;
    }

    /* 2026-07-28: qty change cascades to the paid-option lines of the same
       _config_id (they were staying at qty 1 while the parent went to 2+). */
    fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var main = cart.items.find(function(i) { return i.key === key; });
      var cfgId = main && main.properties ? main.properties['_config_id'] : null;
      if (!main || !cfgId) {
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
      }
      var updates = {};
      updates[key] = qty;
      var oldQty = main.quantity || 1;
      cart.items.forEach(function(item) {
        if (item.key === key) return;
        if (!item.properties || !item.properties['_parent_product']) return;
        if (item.properties['_config_id'] !== cfgId) return;
        var perUnit = (oldQty > 0 && item.quantity % oldQty === 0) ? (item.quantity / oldQty) : 1;
        updates[item.key] = qty * perUnit;
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      isUpdating = false;
      renderCart(cart);
      dispatchChange(cart);
    })
    .catch(function(err) {
      isUpdating = false;
      console.error('[EFCartDrawer] change error', err);
    });
  }

  function removeWithSurcharges(key) {
    fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var mainItem = cart.items.find(function(i) { return i.key === key; });
      var configId = mainItem && mainItem.properties ? mainItem.properties['_config_id'] : null;
      var productTitle = mainItem ? mainItem.product_title : '';
      var updates = {};
      updates[key] = 0;
      cart.items.forEach(function(item) {
        if (!item.properties || !item.properties['_parent_product']) return;
        if (configId && item.properties['_config_id'] === configId) {
          updates[item.key] = 0;
        } else if (!configId && item.properties['_parent_product'] === productTitle) {
          updates[item.key] = 0;
        }
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      isUpdating = false;
      renderCart(cart);
      dispatchChange(cart);
    })
    .catch(function(err) {
      isUpdating = false;
      console.error('[EFCartDrawer] remove error', err);
    });
  }

  function dispatchChange(cart) {
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
  }

  /* §R9-H23 (2026-09-03) — ROUND-9-SPEC H23.
     THIS DOES NOT TOUCH refresh(). It hangs off the `cart:change` event that
     refresh() already dispatches, so open / close / refresh stay byte-for-byte
     what T-CART2 proved. */

  /* Deletion, one line key at a time, through change.js.
     NEVER /cart/update.js: with a key a racing cleanup already removed, update.js
     falls back to the VARIANT id and wipes every line of that variant — a sibling
     configuration's surcharge (feedback_cart_update_stale_key_wipes_variant,
     latent on LIVE as Q13). change.js on a stale key 404s, which is harmless.
     The parent goes LAST so an interrupted run leaves an orphan cleanOrphans()
     already knows how to sweep, rather than a parent with no options. */
  function retireLine(cart, retire) {
    var keys = [];
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p['_parent_product'] && p['_config_id'] === retire.cfgId) keys.push(it.key);
    });
    keys.push(retire.key);
    var ok = true;
    var chain = Promise.resolve(null);
    keys.forEach(function (k) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: k, quantity: 0 })
        }).then(function (r) { if (!r.ok) ok = false; return null; })
          .catch(function () { ok = false; return null; });
      });
    });
    return chain.then(function () {
      if (ok) { try { sessionStorage.removeItem('ef_edit_retire'); } catch (e) {} }
      return ok;
    });
  }

  /* Maps the link stashed at Add-to-cart onto the line that add-to-cart created,
     and — only then — retires the line the buyer was editing. If the buyer
     abandoned the edit, no ATC fired, there is no pending link, and this returns
     before it can delete anything: that IS the "remove only after a successful
     re-add" rule, expressed as a precondition rather than a promise. */
  function claimPendingEdit(cart) {
    var raw = null;
    try { raw = sessionStorage.getItem('ef_edit_pending'); } catch (e) { return; }
    if (!raw) return;
    try { sessionStorage.removeItem('ef_edit_pending'); } catch (e) {}
    var pend = null;
    try { pend = JSON.parse(raw); } catch (e) { pend = null; }
    if (!pend || !pend.link) return;

    var newest = null;
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p['_parent_product'] || !p['_config_id']) return;
      newest = it;                       /* last configured parent in cart order */
    });
    if (!newest) return;
    var newCfg = newest.properties['_config_id'];
    try { localStorage.setItem('ef_edit_' + newCfg, pend.link); } catch (e) {}

    var rraw = null;
    try { rraw = sessionStorage.getItem('ef_edit_retire'); } catch (e) {}
    var ret = null;
    if (rraw) { try { ret = JSON.parse(rraw); } catch (e) { ret = null; } }
    var stillThere = ret && cart.items.some(function (i) { return i.key === ret.key; });
    if (ret && !stillThere) { try { sessionStorage.removeItem('ef_edit_retire'); } catch (e) {} ret = null; }
    if (ret && ret.key !== newest.key && ret.cfgId !== newCfg) {
      retireLine(cart, ret).then(function (ok) { if (ok) refresh(); });
      return;
    }
    /* No retirement: re-render once so the control appears on the build that was
       just added, instead of on the next page load. */
    renderCart(cart);
  }

  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && cart.items) claimPendingEdit(cart);
  });

  /* ── Events: quantity & remove ── */
  itemsEl.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-action');
    var key = btn.getAttribute('data-key');
    if (action === 'remove') {
      changeItem(key, 0);
    } else if (action === 'edit') {
      /* §R9-H23. Re-read the key at click time — the render could be stale.
         The line is NOT removed here; it is retired only once the re-add lands. */
      var cfg = btn.getAttribute('data-cfg');
      var href = null;
      try { href = localStorage.getItem('ef_edit_' + cfg); } catch (err) { href = null; }
      if (!href) return;
      try { sessionStorage.setItem('ef_edit_retire', JSON.stringify({ key: key, cfgId: cfg, t: Date.now() })); } catch (err) {}
      window.location.href = href;
    } else if (action === 'minus') {
      var span = btn.parentElement.querySelector('span');
      var current = parseInt(span.textContent, 10);
      if (current > 1) changeItem(key, current - 1);
      else changeItem(key, 0);
    } else if (action === 'plus') {
      var span = btn.parentElement.querySelector('span');
      var current = parseInt(span.textContent, 10);
      changeItem(key, current + 1);
    }
  });

  /* ── Events: close ── */
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  if (contBtn) contBtn.addEventListener('click', close);
  /* Empty-state "Continue Shopping" — closes drawer (same as X / overlay) */
  var emptyContinueBtn = document.getElementById('ef-drawer-empty-continue');
  if (emptyContinueBtn) emptyContinueBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  /* ── Intercept cart link clicks (except "View Full Cart" inside drawer
        and except links with data-direct-checkout — those handle their own
        navigation flow, e.g. "More Payment Options" on standard PDP that
        adds to cart then redirects directly to /checkout). ── */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href="/cart"], a[href="/cart/"], [data-cart-count], .js-cart-count, [data-action="open-cart"], [aria-controls="cart-drawer"]');
    if (link && !link.closest('#ef-drawer-panel') && !link.hasAttribute('data-direct-checkout')) {
      e.preventDefault();
      e.stopPropagation();
      open();
    }
  }, true); // capture phase to beat theme handlers

  /* ── Global API ── */
  window.EFCartDrawer = {
    open: open,
    close: close,
    refresh: refresh
  };
})();
